import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "pl-xl-2 pl-xl-2 pl-mb-1" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "card-title mb-4" }, "Calificación de llamada")
], -1)
const _hoisted_5 = { class: "ml-auto" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sync" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-window-restore" })
], -1)
const _hoisted_8 = { class: "container ct-example-row mb-4 px-0" }
const _hoisted_9 = { class: "w-100" }
const _hoisted_10 = { class: "row m-0" }
const _hoisted_11 = { class: "float-sm-right mt-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left" }),
  /*#__PURE__*/_createTextVNode(" Cancelar ")
], -1)
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = {
  key: 1,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = {
  key: 1,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Finalizar gestión ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

import { Form, FormActions } from "vee-validate";
import { Field } from "@/types/components";
import {
	computed,
	defineAsyncComponent,
	onBeforeUnmount,
	onMounted,
	ref,
	watch,
} from "vue";
import { Promotion, DocumentAdd } from "@element-plus/icons";
import { CallDataModule } from "@/store/modules/CallData";
import { generateDynamicSchema } from "@/store/schemas/client.schema";
import { env } from "@/config";
import { dynamicForm } from "@/util/consts";
import { ISaveCallType } from "@/types/call";
import { WarningFilled } from "@element-plus/icons-vue";
import useFormModal from "@/composables/FormModalComposable";
import {
	TypificationModalModule,
	actionType,
} from "@/store/modules/TypificationModal";
import { IndexType } from "@/types/store";
import { HistoryModule } from "@/store/modules/History";
import { AuthModule } from "@/store/modules/Auth";
import { IPagination } from "../omni";
import { coreApi } from "@/conection";
import { iInvalidSubmit } from "@/composables/vee-validate";
import { AlertModule } from "@/store/modules/Alert";
import { AppModule } from "@/store/modules/app";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const TypificationModal = defineAsyncComponent(
	() => import("@/callcenter/components/DynamicTypificationModal.vue")
);

// ===> Data
const showModal = ref<boolean>(false);
const form = ref<IndexType<Field>>({});
const formkey = ref(0);
const error = ref("");
const formComponent = ref<
	| (FormActions<any> & {
			getValues: () => { [k: string]: string | undefined };
	  })
	| null
>(null);

// ==> Computed
const schema = computed(() =>
	generateDynamicSchema(Object.values(form.value as IndexType<Field>))
);

const allowMultiCalification = computed(
	() => AppModule.appConfig.call_calification === "multiple"
);

const formData = computed<any>(() => {
	return TypificationModalModule.data;
});

const loading = computed(() => {
	return CallDataModule.getLoadingCallRating;
});
const loadingDelete = computed(() => {
	return CallDataModule.getLoadingCallDelete;
});

const edit = computed(() => {
	return TypificationModalModule.type === actionType.edit;
});
const editId = computed(() => {
	return TypificationModalModule.idSql;
});

const { getComponent, getProps, isHidden } = useFormModal();

/**
 *  Methods
 */

async function onSubmit(e: any, { resetForm }: any) {
	const payload: { [k: string]: any } = {};
	const payload2: { [k: string]: any } = {};

	await Object.keys(e).forEach(inputName => {
		if(!form.value[inputName]) return;
		const key = form.value[inputName].options?.label ?? "label";

		payload[inputName] =
			form.value[inputName].type === "options" && e[inputName]
				? e[inputName][key]
				: e[inputName];

		if (form.value[inputName].type === "options")
			payload2[inputName] = e[inputName];
	});

	if (edit.value) {
		const success = await CallDataModule.updateEvaluation({
			form: payload2,
			data: payload,
		});
		if (success) {
			const pag: IPagination = {
				sendNumber: false,
				agentCode: AuthModule.user?.code,
				today: true,
			};
			resetForm();
			HistoryModule.updateUserHistory(pag);
			cancelEdit();
			TypificationModalModule.setData({});
		}
	} else {
		const { success } = await CallDataModule.sendEvaluation({
			Evaluation: {},
			data: payload,
			data2: payload2,
		});
		if (success) {
			resetForm();
			TypificationModalModule.setData({});
		}
	}
	loadData();
}
let espera = false;
async function deleteActiveCall() {
	if (espera || loadingDelete.value) return;
	console.log("Entro en deleteActiveCall");
	espera = true;
	CallDataModule.setSaveCallType(ISaveCallType.deleteCall);
	const res = await CallDataModule.deleteMysqlActiveCall({});
	if (!res.success) {
		CallDataModule.setSaveCallType(ISaveCallType.single);
	} else {
		TypificationModalModule.setData({});
		formComponent.value?.resetForm();
	}

	espera = false;
}

const scorign = computed(() => {
	return CallDataModule.scoring;
});

const loadData = () => {
	Object.keys(form.value).forEach(input => {
		form.value[input].value = formData.value[input]
			? formData.value[input]
			: undefined;
		form.value[input].disabled = edit.value
			? form.value[input].blockOnEdit
			: false;
	});
};

const cancelEvent = () => {
	console.log("cancel!");
};

const changeModal = ({ show }: { show: boolean }) => {
	showModal.value = show;
	if (!show) loadData();
};

async function reloadForm() {
	coreApi.post("/api/log", {
		formkey: formkey.value,
		form: form.value,
		formData: formData.value,
	});
	await mountForm();
	formkey.value = formkey.value + 1;
	coreApi.post("/api/log", {
		formkey: formkey.value,
		form: form.value,
		formData: formData.value,
	});
}
function openModal() {
	TypificationModalModule.setData(
		formComponent.value?.getValues() as { [k: string]: string | undefined }
	);
	changeModal({ show: true });
}

function cancelEdit() {
	TypificationModalModule.setType(actionType.create);
	TypificationModalModule.setIdSql(null);
	TypificationModalModule.setIdMongo(null);
	TypificationModalModule.setData({});
	CallDataModule.setUser(undefined);
	CallDataModule.setActiveCall({
		call_number: "",
		uniqueid: "",
		call_status: undefined,
		resultado: 0,
		call_type: "",
		queue: "",
		id: "",
	});
	CallDataModule.setScore(false);
	CallDataModule.updateActiveCall();
}

watch(
	() => editId.value,
	() => {
		if (editId.value !== 0) loadData();
	}
);

async function mountForm() {
	let options: { [k: string]: object } | null = null;
	if (dynamicForm) {
		const dataForm =
			AppModule.configs.find(c => c.name === "dynamic_typification")?.data ??
			(await dynamicForm);
		form.value = dataForm.reduce((acc, field) => {
			acc[field.name] = field;
			if (field.type === "options" && field.staticOptions?.length) {
				const opts = field.staticOptions.reduce((acc2, option) => {
					acc2[field.name] = {
						...acc2[field.name],
						[option.label]: { value: option.value, label: option.label },
					};
					return acc2;
				}, {} as { [k: string]: Field });
				options = options ? { ...options, ...opts } : { ...opts };
			}
			return acc;
		}, {} as { [k: string]: Field });
	}
	if (options) TypificationModalModule.setOptions(options);
}

onMounted(async () => {
	await mountForm();
	// Cargar data si detecta datos en vuex
	if (Object.keys(TypificationModalModule.data).length) loadData();
});

onBeforeUnmount(() =>
	TypificationModalModule.setData(formComponent.value?.getValues() ?? {})
);
function onInvalidSubmit(values: iInvalidSubmit) {
	console.log(values);
	const errMsgs: string[] = [];
	Object.keys(values.errors).forEach(key => {
		errMsgs.push(form.value[key.split(".")[0]]?.label);
	});
	AlertModule.SOCKET_PUSH_NOTIFICATION({
		text: `Por favor verifique los siguientes campos: ${errMsgs.join()}`,
		type: "error",
	});
}

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_card, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_el_tooltip, { content: "Recargar formulario" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_button, {
                      type: "warning",
                      size: "sm",
                      disabled: !_unref(scorign) && !_unref(edit),
                      onClickCapture: reloadForm
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_tooltip, { content: "Ampliar formulario" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_base_button, {
                      type: "primary",
                      size: "sm",
                      disabled: !_unref(scorign) && !_unref(edit),
                      onClickCapture: openModal
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createBlock(_unref(Form), {
                class: "w-100",
                ref_key: "formComponent",
                ref: formComponent,
                key: formkey.value,
                "validation-schema": _unref(schema),
                onSubmit: onSubmit,
                onInvalidSubmit: onInvalidSubmit
              }, {
                default: _withCtx(({ values, setFieldValue }) => [
                  (error.value)
                    ? (_openBlock(), _createBlock(_component_el_alert, {
                        key: 0,
                        title: error.value,
                        type: "error",
                        "show-icon": "",
                        onClose: _cache[0] || (_cache[0] = () => (error.value = ''))
                      }, null, 8, ["title"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_scrollbar, { "max-height": "210px" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(form.value), (input, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass({
											'd-none': _unref(isHidden)(input as Field, values, setFieldValue),
											'col-12 col-md-6': input.type !== 'title',
											'col-12': input.type === 'title',
										}),
                              key: index
                            }, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent((_unref(getComponent)(input.type) as any)), _mergeProps({
                                hidden: _unref(isHidden)(input as Field, values, setFieldValue),
                                class: {
												'upload-control w-100': input.type === 'file',
												...(input.className ? { [input.className]: true } : {}),
											}
                              }, _unref(getProps)(input as Field, values), {
                                name: input.name,
                                type: input.type,
                                label: input.label,
                                placeholder: input.placeholder,
                                "small-label": ""
                              }), null, 16, ["hidden", "class", "name", "type", "label", "placeholder"]))
                            ], 2))
                          }), 128))
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_11, [
                    (_unref(edit))
                      ? (_openBlock(), _createBlock(_component_base_button, {
                          key: 0,
                          type: "danger",
                          size: "sm",
                          onClickCapture: cancelEdit
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_base_button, {
                      type: "success",
                      size: "sm",
                      nativeType: "submit",
                      disabled: (!_unref(scorign) && !_unref(edit)) || _unref(loading),
                      onClickCapture: _cache[1] || (_cache[1] = ($event: any) => (
									_unref(CallDataModule).setSaveCallType(
										_unref(env).MultipleTypification
											? _unref(ISaveCallType).saveCall
											: _unref(ISaveCallType).single
									)
								))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          (!_unref(loading))
                            ? (_openBlock(), _createBlock(_component_el_icon, {
                                key: 0,
                                size: 20,
                                color: "#FFFFF",
                                class: "no-inherit"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Promotion))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_unref(loading))
                            ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_unref(edit) ? "Actualizar evaluación" : "Enviar evaluación"), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_popconfirm, {
                      "confirm-button-text": "Sí",
                      "cancel-button-text": "No",
                      icon: _unref(WarningFilled),
                      "icon-color": "#F0463A",
                      width: "235",
                      "show-after": 0,
                      "hide-after": 0,
                      title: "¿Quiere finalizar la gestión?",
                      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (deleteActiveCall())),
                      onCancel: _cache[3] || (_cache[3] = ($event: any) => (cancelEvent())),
                      "popper-options": { gpuAcceleration: false },
                      teleported: false
                    }, {
                      reference: _withCtx(() => [
                        (_unref(allowMultiCalification) && !_unref(edit))
                          ? (_openBlock(), _createBlock(_component_base_button, {
                              key: 0,
                              type: "danger",
                              size: "sm",
                              disabled: !_unref(scorign)
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_15, [
                                  (!_unref(loading))
                                    ? (_openBlock(), _createBlock(_component_el_icon, {
                                        key: 0,
                                        size: 20,
                                        color: "#FFFFF",
                                        class: "no-inherit"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(DocumentAdd))
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  (_unref(loadingDelete))
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                                    : _createCommentVNode("", true),
                                  _hoisted_17
                                ])
                              ]),
                              _: 1
                            }, 8, ["disabled"]))
                          : _createCommentVNode("", true),
                        _hoisted_18
                      ]),
                      _: 1
                    }, 8, ["icon"])
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"]))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "miniFadeInUp",
      "leave-active-class": "miniFadeOutUp"
    }, {
      default: _withCtx(() => [
        (showModal.value)
          ? (_openBlock(), _createBlock(_unref(TypificationModal), {
              key: 0,
              open: showModal.value,
              onChangeModal: _cache[4] || (_cache[4] = s => changeModal(s))
            }, null, 8, ["open"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})